import {genCompositeId} from 'module/Properties/util/PropertiesUtil';
import {getAppName} from 'util/AppName';
import {PropertyTypeEnum} from 'module/Properties/enum/PropertyTypeEnum'

export class PropertyID {
	readonly object: string
	readonly subkrit: string | undefined
	readonly attribute: string
	readonly type: PropertyTypeEnum

	/**
	 * @param object
	 * @param attribute
	 * @param type
	 * @param subkrit only for paramdiv
	 */
	constructor(object: string, attribute: string, type: PropertyTypeEnum = PropertyTypeEnum.UserProperty, subkrit?: string) {
		this.object = object
		this.subkrit = subkrit
		this.attribute = attribute
		this.type = type
	}

	toString() {
		return genCompositeId(this.object, this.attribute, this.type, this.subkrit);
	}
}


const appName = getAppName()

/**
 * define ids of properties here for easy usage
 * @type {*} enum
 */
export const PropID = {
	evoApps_personListTemplate: new PropertyID("evoApps", "personListTemplate"),
	evoApps_showPersonInfoButtonInSidePanel: new PropertyID('evoApps', 'showPersonInfoButtonInSidePanel'),
	evoApps_colorWithoutSoll: new PropertyID("evoApps", "farbeOhneSoll"),
	evoApps_dayInfoColors: new PropertyID("evoApps", "farbenSollIst"),
	evoApps_dayInfoColorsMaxLimit: new PropertyID("evoApps", "farbenSollIstMaxLimit"),
	evoApps_durFormat: new PropertyID("sisworld.sfa.appservlet.sissfamodule", "DurFormat", PropertyTypeEnum.IProperty),
	evoApps_askForBigSelectionAmountInSelPan: new PropertyID("evoApps", "askForBigSelectionAmountInSelPan"),
	evoApps_mailVertretungMaxAmount: new PropertyID("evoApps", "mailVertretungMaxAmount"),
	evoApps_mailVertretungAllowFwd: new PropertyID("evoApps", "mailVertretungAllowFwd"),
	evoApps_mailVertretungGlobalFwdSwitch: new PropertyID("evoApps", "mailVertretungGlobalFwdSwitch"),
	evoApps_showStuartBuartShortKey: new PropertyID("evoApps", "showStuartBuartShortKey"),
	evoApps_notiButtonShowAlways: new PropertyID("evoApps", "notiButtonShowAlways"),
	evoApps_newAzeDialog: new PropertyID("evoApps", "newAzeDialog"),
	home_showVersionInfo: new PropertyID('home', 'showVersionInfo'),
	home_warnIE11: new PropertyID('home', 'warnIE11'),
	eventDialog_print: new PropertyID("eventDialog", "drucken"),
	eventDialog_favDefault: new PropertyID("eventDialog", "favDefault"),
	workflow_pageSize: new PropertyID("workflow", "pageSize"),
	workflow_bulkGenAbl: new PropertyID(appName, "bulkGenAbl"),
	bookingCalendar_bewertungButton: new PropertyID("bookingCalendar", "bewertungButton"),
	bookingCalendar_bookingButton: new PropertyID("bookingCalendar", "bookingButton"),
	bookingCalendar_bplanButton: new PropertyID("bookingCalendar", "bplanButton"),
	bookingCalendar_buchungsschlussButton: new PropertyID("bookingCalendar", "buchungsschlussButton"),
	bookingCalendar_persurlButton: new PropertyID("bookingCalendar", "persurlButton"),
	bookingCalendar_kontierungButton: new PropertyID("bookingCalendar", "kontierungButton"),
	bookingCalendar_wocheFreigebenButton: new PropertyID("bookingCalendar", "wocheFreigebenButton"),
	bookingCalendar_wochenBelegButton: new PropertyID("bookingCalendar", "wochenBelegButton"),
	bookingCalendar_infoButton: new PropertyID("bookingCalendar", "infoButton"),
	bookingCalendar_teamcalendarButton: new PropertyID("bookingCalendar", "teamcalendarButton"),
	bookingCalendar_dragAndDropEvents: new PropertyID("bookingCalendar", "dragAndDropEvents"),
	bookingCalendar_resizeEvents: new PropertyID("bookingCalendar", "resizeEvents"),
	bookingCalendar_viewMonthButton: new PropertyID("bookingCalendar", "viewMonthButton"),
	bookingCalendar_viewWeekButton: new PropertyID("bookingCalendar", "viewWeekButton"),
	bookingCalendar_viewDayButton: new PropertyID("bookingCalendar", "viewDayButton"),
	resourceCalendar_personPageSize: new PropertyID("resourceCalendar", "personPageSize"),
	resourceCalendar_showPresencePlanning: new PropertyID("resourceCalendar", "showPresencePlanning"),
	resourceCalendar_showPresencePlanningAbsent: new PropertyID("resourceCalendar", "showPresencePlanningAbsent"),
	resourceCalendar_showSumAnwesend: new PropertyID("resourceCalendar", "showSumAnwesend"),
	resourceCalendar_showSumAbwesend: new PropertyID("resourceCalendar", "showSumAbwesend"),
	resourceCalendar_showSumAbwesendPersurl: new PropertyID("resourceCalendar", "showSumAbwesendPersurl"),
	resourceCalendar_showSumAbwesendPersurlSoll: new PropertyID("resourceCalendar", "showSumAbwesendPersurlSoll"),
	resourceCalendar_showSumSoll: new PropertyID("resourceCalendar", "showSumSoll"),
	resourceCalendar_rowHeaderMinWidth: new PropertyID("resourceCalendar", "rowHeaderMinWidth"),
	resourceCalendar_bookingButton: new PropertyID("resourceCalendar", "bookingButton"),
	resourceCalendar_persurlButton: new PropertyID("resourceCalendar", "persurlButton"),
	resourceCalendar_dragAndDropEvents: new PropertyID("resourceCalendar", "dragAndDropEvents"),
	resourceCalendar_resizeEvents: new PropertyID("resourceCalendar", "resizeEvents"),
	resourceCalendar_viewMonthButton: new PropertyID("resourceCalendar", "viewMonthButton"),
	resourceCalendar_viewWeekButton: new PropertyID("resourceCalendar", "viewWeekButton"),
	resourceCalendar_viewTwoWeekButton: new PropertyID("resourceCalendar", "viewTwoWeekButton"),
	onClient_sortAlwaysOnTop: new PropertyID("onClient", "sortAlwaysOnTop"),
	onClient_disablePersonsByKost: new PropertyID("onClient", "disablePersonsByKost"),
	onClient_copyPaste: new PropertyID("onClient", "copyPaste"),
	onClient_enableCopyPasteInMultiKost: new PropertyID("onClient", "enableCopyPasteInMultiKost"),
	onClient_enableInitEntries: new PropertyID("onClient", "enableInitEntries"),
	onClient_multiKostInputShows: new PropertyID("onClient", "multiKostInputShows"),
	onClient_multiKostRememberChoice: new PropertyID("onClient", "multiKostRememberChoice"),
	onClient_multiKostInitShowDialog: new PropertyID("onClient", "multiKostInitShowDialog"),
	onClient_multiKostInitMaxAmount: new PropertyID("onClient", "multiKostInitMaxAmount"),
	onClient_multiKostInitWithStammKost: new PropertyID("onClient", "multiKostInitWithStammKost"),
	onClient_monthMode: new PropertyID('onClient', 'monthMode'),
	onClient_copyDoneMessage: new PropertyID('onClient', 'copyDoneMessage'),
	onClient_overviewButton: new PropertyID("onClient", "overviewButton"),
	onClient_personInfoButton: new PropertyID("onClient", "personInfoButton"),
	onClient_maxPageSize: new PropertyID('onClient', 'maxPageSize'),
	onClient_initMethod: new PropertyID('onClient', 'initMethod'),
	onClient_initBerechoffcNoSoll: new PropertyID('onClient', 'initBerechoffcNoSoll'),
	terminal_personInput: new PropertyID("terminal", "personInput"),
	terminal_showVlErrorsView: new PropertyID("terminal", "verrechnungsmeldungen"),
	terminal_padInputType: new PropertyID("terminal", "padInputType"),
	terminal_customFieldLabelPos: new PropertyID("terminal", "customFieldLabelPos"),
	terminal_showDefaultTextField: new PropertyID("terminal", "showDefaultTextField"),
	terminal_switchToTwoColumnAt: new PropertyID("terminal", "switchToTwoColumnAt"),
	terminal_bookingListTemplate: new PropertyID("terminal", "bookingListTemplate"),
	terminal_bookingListHideCfDef: new PropertyID("terminal", "bookingListHideCfDef"),
	terminal_bookingListShowDqLabelCfDef: new PropertyID("terminal", "bookingListShowDqLabelCfDef"),
	terminal_azeBookingListTemplate: new PropertyID("terminal", "azeBookingListTemplate"),
	terminal_clearCFBufferOnCancel: new PropertyID("terminal", "clearCFBufferOnCancel"),
	terminal_keepFormOpen: new PropertyID("terminal", "keepFormOpen"),
	terminal_allowOverrideTime: new PropertyID("terminal", "allowOverrideTime"),
	terminal_preventFutureBooking: new PropertyID("terminal", "preventFutureBooking"),
	terminal_maxPastPeriodBooking: new PropertyID("terminal", "maxPastPeriodBooking"),
	terminal_allowDeleteBookings: new PropertyID("terminal", "allowDeleteBookings"),
	terminal_cfFormButtonLabelOK: new PropertyID('terminal', 'cfFormButtonLabelOK'),
	terminal_cfFormButtonLabelCancel: new PropertyID('terminal', 'cfFormButtonLabelCancel'),
	timelineTask_maxTasksSelected: new PropertyID("timelineTask", "maxTasksSelected"),
	planTemplate_pause: new PropertyID("planTemplate", "pause"),
	planTemplate_wochenTolera: new PropertyID("planTemplate", "wochenTolera"),
	planTemplate_showSoll: new PropertyID("planTemplate", "showSoll"),
	planTemplate_freigabe: new PropertyID("planTemplate", "freigabe"),
	planTemplate_enablePeriode: new PropertyID("planTemplate", "enablePeriode"),
	planTemplate_persNrMode: new PropertyID("planTemplate", "persNrMode"),
	planTemplate_enableEndDateInput: new PropertyID("planTemplate", "enableEndDateInput"),
	planTemplate_planPersDeletable: new PropertyID("planTemplate", "planPersDeletable"),
	planTemplate_planMastChangeableWhenPlanPersExists: new PropertyID("planTemplate", "planMastChangeableWhenPlanPersExists"),

	// these only return true if menu allows these apps
	showBookingCalendarButton: new PropertyID("evoApps", "showBookingCalendarButton", PropertyTypeEnum.VirtualProperty),
	showResourceCalendarButton: new PropertyID("evoApps", "showResourceCalendarButton", PropertyTypeEnum.VirtualProperty),
	showOnClientButton: new PropertyID("evoApps", "showOnClientButton", PropertyTypeEnum.VirtualProperty),
	showTimelineButton: new PropertyID("evoApps", "showTimelineButton", PropertyTypeEnum.VirtualProperty),
	showTimelineTaskButton: new PropertyID("evoApps", "showTimelineTaskButton", PropertyTypeEnum.VirtualProperty),

	/*
	 * app scoped properties - object is always sisAppName
	 */

	// timeline, resourceCalendar
	persInfPerRow: new PropertyID(appName, "persInfPerRow"), // [code:fkey,...]
	persInfPerRowSizes: new PropertyID(appName, "persInfPerRowSizes"), // [width,width,...]
	persInfPerRowTitles: new PropertyID(appName, "persInfPerRowTitles"), // [title,title,...]
	// timelineTask
	taskPerRow: new PropertyID(appName, "taskPerRow"), // [dqkey,...]
	taskPerRowSizes: new PropertyID(appName, "taskPerRowSizes"), // [width,width,...]
	taskPerRowTitles: new PropertyID(appName, "taskPerRowTitles"), // [title,title,...]
	// timeline, timelineTask
	auswertungButton: new PropertyID(appName, "auswertungButton"),
	kostAuswertungButton: new PropertyID(appName, 'kostAuswertungButton'),
	// vis
	buchungVis: new PropertyID(appName, "buchungVis"),
	persurlVis: new PropertyID(appName, "persurlVis"),
	persstVis: new PropertyID(appName, "persstVis"),
	stTagVis: new PropertyID(appName, "stTagVis"),
	stTagModelVis: new PropertyID(appName, "stTagModelVis"),
	stTagDetailVis: new PropertyID(appName, "stTagDetailVis"),
	stTagNormalVis: new PropertyID(appName, "stTagNormalVis"),
	stTagKernVis: new PropertyID(appName, "stTagKernVis"),
	stTagGlzVis: new PropertyID(appName, "stTagGlzVis"),
	feiertageVis: new PropertyID(appName, "feiertageVis"),
	taskZuVis: new PropertyID(appName, "taskZuVis"),
	sumAnVis: new PropertyID(appName, "sumAnVis"),
	sumAbVis: new PropertyID(appName, "sumAbVis"),
	sumPersurlVis: new PropertyID(appName, "sumPersurlVis"),
	sumPersurlWhenSollVis: new PropertyID(appName, "sumPersurlWhenSollVis"),
	sumSollVis: new PropertyID(appName, "sumSollVis"),
	sumNoTaskZuVis: new PropertyID(appName, "sumNoTaskZuVis"),
	sumNormalVis: new PropertyID(appName, "sumNormalVis"),
	sumKernVis: new PropertyID(appName, "sumKernVis"),
	sumGleitVis: new PropertyID(appName, "sumGleitVis"),
	//default overrides
	buchungDefault: new PropertyID(appName, "buchungDefault"),
	persurlDefault: new PropertyID(appName, "persurlDefault"),
	persstDefault: new PropertyID(appName, "persstDefault"),
	stTagDefault: new PropertyID(appName, "stTagDefault"),
	stTagModelDefault: new PropertyID(appName, "stTagModelDefault"),
	stTagDetailDefault: new PropertyID(appName, "stTagDetailDefault"),
	stTagNormalDefault: new PropertyID(appName, "stTagNormalDefault"),
	stTagKernDefault: new PropertyID(appName, "stTagKernDefault"),
	stTagGlzDefault: new PropertyID(appName, "stTagGlzDefault"),
	feiertageDefault: new PropertyID(appName, "feiertageDefault"),
	taskZuDefault: new PropertyID(appName, "taskZuDefault"),
	sumAnDefault: new PropertyID(appName, "sumAnDefault"),
	sumAbDefault: new PropertyID(appName, "sumAbDefault"),
	sumPersurlDefault: new PropertyID(appName, "sumPersurlDefault"),
	sumPersurlWhenSollDefault: new PropertyID(appName, "sumPersurlWhenSollDefault"),
	sumSollDefault: new PropertyID(appName, "sumSollDefault"),
	sumNoTaskZuDefault: new PropertyID(appName, "sumNoTaskZuDefault"),
	sumNormalDefault: new PropertyID(appName, "sumNormalDefault"),
	sumKernDefault: new PropertyID(appName, "sumKernDefault"),
	sumGleitDefault: new PropertyID(appName, "sumGleitDefault"),

	itemMinWidthPercentage: new PropertyID(appName, 'itemMinWidthPercentage'),
	pageSizeDefaultPerson: new PropertyID(appName, 'pageSizeDefaultPerson'),
	pageSizeDefaultTask: new PropertyID(appName, 'pageSizeDefaultTask'),
	// Task
	taskTTL: new PropertyID(appName, "taskTTL"),
	// TaskZuDialog
	taskZuFixedSplit: new PropertyID(appName, "taskZuFixedSplit"),
	taskZuBlockOverlap: new PropertyID(appName, "taskZuBlockOverlap"),
	taskZuTooltipAdditionalContent: new PropertyID(appName, "taskZuTooltipAdditionalContent"),
	// PersstDialog
	persstDialog: new PropertyID(appName, "persstDialog"),
	// Freigabe
	showFreigabePers: new PropertyID(appName, "showFreigabePers"),
	freigabeKostVorgInput: new PropertyID(appName, "FreigabeKostVorgInput", PropertyTypeEnum.VirtualProperty),
	freigabePersDateEdit: new PropertyID(appName, "freigabePersDateEdit"),
	showFreigabeKost: new PropertyID(appName, "showFreigabeKost"),
	freigabePersScope: new PropertyID(appName, "freigabePersScope"),
	freigabeKostScope: new PropertyID(appName, "freigabeKostScope"),
	freigabeKostDateEdit: new PropertyID(appName, "freigabeKostDateEdit"),
	freigabeKostText: new PropertyID(appName, "freigabeKostText"),
	freigabeKostIconOpen: new PropertyID(appName, "freigabeKostIconOpen"),
	freigabeKostIconDone: new PropertyID(appName, "freigabeKostIconDone"),
	//timeline, timelineTask, bookingCalendar, resourceCalendar
	printButton: new PropertyID(appName, "printButton"),
	//efile
	eFileButtonShowAuft: new PropertyID(appName, "eFileButtonShowAuft"),
	eFileButtonShowKost: new PropertyID(appName, "eFileButtonShowKost"),
	eFileButtonShowPers: new PropertyID(appName, "eFileButtonShowPers"),
	eFileButtonShowTask: new PropertyID(appName, "eFileButtonShowTask"),
	// entity text
	textAuft: new PropertyID("KONT", "TEXT", PropertyTypeEnum.Paramdiv, "AUFT"),
	textKost: new PropertyID("KONT", "TEXT", PropertyTypeEnum.Paramdiv, "KOSTENST"),
}

//todo test bookings-block (userwechsel geht nicht), grüner daumen -> farben?, doku